import './application_globals';
import './global_imports';
import FlashMessages from './../../scripts/utilities/flash_message';
import ModalCart from './../../scripts/cart/modal';
import Translator from './../../scripts/translator';
import TrackingManager from './../../scripts/tracking/tracking_manager';
import TrackingAnalytics from './../../scripts/tracking/tracking_analytics';
import UiLock from './../../scripts/utilities/ui_lock';

// add ability to spread attributes inside object in jsx
React.__spread = Object.assign;

/**
 * Tyroola namespace
 * @type {Object}
 */
window.TYROOLA = window.TYROOLA || {};

/**
 * Entry point for application scripts
 */
var $container  = $('body > .page-container'),
    translator = new Translator(TYROOLA.translations);

function initialisePage(Page) {
    "use strict";
    if (!Page.noParameters) {
        TYROOLA.flashMessages = new FlashMessages();
        TYROOLA.modalCart     = new ModalCart($('.cart-modal-container'));
        TYROOLA.tracking = new TrackingManager(new TrackingAnalytics());

        TYROOLA.page = new Page(
            $container,
            TYROOLA.flashMessages,
            TYROOLA.modalCart,
            new UiLock()
        );
    } else {
        TYROOLA.page = new Page();
    }

    if (!Page.ignoreTrackers) {
        TYROOLA.tracking.registerTrackers(TYROOLA.page.getTrackerConfig());
    }

    if (!Page.ignoreTranslations) {
        TYROOLA._t = translator.translate;
    }

    //Intialise page when document is ready
    if (TYROOLA.page.init) {
        TYROOLA.page.init();
    }

    $(function() {
        //Intialise tracker when document is ready
        if (!Page.ignoreTrackers) {
            TYROOLA.tracking.init();
        }
    });
}

export default initialisePage;